import {formatFirmwareVersion} from "core/utils/firmwareUtils";

const GENERAL_BICYCLE_INFO_FORM = {
  fields: [
    {
      name: 'system.name',
      label: 'bicycle_info.system_name_field',
      type: 'info',
      styles: {
        maxWidth: '500px',
        marginTop: '2em'
      },
      getValue: (data) => {
        return data.system.name;
      },
    },
    {
      name: 'number',
      label: 'bicycle_info.number_field',
      type: 'info',
      styles: {
        maxWidth: '500px'
      },
      getValue: (data) => {
        return data.number + '';
      }
    },
    {
      name: 'model',
      label: 'bicycle_info.model_field',
      type: 'info',
      styles: {
        maxWidth: '500px'
      }
    },
    {
      name: 'serialNumber',
      label: 'bicycle_info.serial_number_field',
      type: 'info',
      styles: {
        maxWidth: '500px'
      }
    },
    {
      name: 'location',
      label: 'bicycle_info.location_field',
      type: 'info',
      getValue: (data) => {
        return data.location.label;
      },
      styles: {
        maxWidth: '500px'
      }
    },
    {
      name: 'lockMacAddress',
      label: 'bicycle_info.lock_mac_address_field',
      type: 'info',
      styles: {
        maxWidth: '500px'
      }
    },
    {
      name: 'firmwareVersion',
      label: 'bicycle_info.firmware_version_field',
      type: 'info',
      getValue: (data) => {
        return formatFirmwareVersion(data.firmwareVersion)
      },
      styles: {
        maxWidth: '500px'
      }
    },
    {
      name: 'ulockKey',
      label: 'bicycle_info.u_lock_key_field',
      type: 'info',
      getValue: (data) => {
        return data.ulockKey ? data.ulockKey : 'none'
      },
      styles: {
        maxWidth: '500px'
      }
    },
    {
      name: 'powerLevel',
      label: 'bicycle_info.power_level_field',
      type: 'any',
      translate: true,
      getStyle(raw) {
        if (!raw.lastScan) {
          return {maxWidth: '500px'};
        }

        const lastScan = new Date(raw.lastScan);
        const expiryScanDate = new Date(lastScan).setDate(lastScan.getDate() + 30);

        if (raw.powerLevel && expiryScanDate > new Date().getTime()) {
          if (expiryScanDate < new Date().getTime()) {
            return {color: '#f44336', maxWidth: '500px'};
          }

          if (raw.powerLevel >= 80) {
            return {color: '#4CAF50', maxWidth: '500px'};
          } else if (raw.powerLevel >= 50) {
            return {color: '#FF9800', maxWidth: '500px'};
          } else if (raw.powerLevel < 50) {
            return {color: '#f44336', maxWidth: '500px'};
          }
        }

        return {maxWidth: '500px'};
      },
      getValue(raw) {
        if (!raw.lastScan) {
          return 'power_level.none';
        }

        const lastScan = new Date(raw.lastScan);
        const expiryScanDate = new Date(lastScan).setDate(lastScan.getDate() + 30);

        if (raw.powerLevel && expiryScanDate > new Date().getTime()) {
          if (raw.powerLevel >= 80) {
            return 'power_level.good';
          } else if (raw.powerLevel >= 50) {
            return 'power_level.low';
          } else if (raw.powerLevel < 50) {
            return 'power_level.bad';
          }
        }

        return 'power_level.none';
      },
      styles: {
        maxWidth: '500px'
      }
    },
    {
      name: 'lastScan',
      label: 'bicycle_info.last_scan_field',
      type: 'info',
      getValue: (data) => {
        return data.lastScan ? data.lastScan : '-'
      },
      getStyle(raw) {
        if (!raw.lastScan) {
          return {};
        }

        const lastScan = new Date(raw.lastScan);
        const expiryScanDate = new Date(lastScan).setDate(lastScan.getDate() + 30);

        if (expiryScanDate < new Date().getTime()) {
          return {color: '#f44336'};
        }

        return {};
      },
      styles: {
        maxWidth: '500px'
      }
    },
    {
      name: 'status',
      label: 'bicycle_info.status_field',
      type: 'info',
      translate: true,
      getValue: (data) => {
        return 'bike_status.' + data.status;
      },
      styles: {
        maxWidth: '500px'
      }
    }
  ]
}

export default GENERAL_BICYCLE_INFO_FORM;
